"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const PublisherCard_1 = __importDefault(require("@Components/ViewWork/PublisherCard"));
require("./index.scss");
const clsx_1 = __importDefault(require("clsx"));
const PublisherComponent = (props) => {
    const { publisher, publisherError, admin, adminPublisherError, publicContact, workType } = props;
    const primary = admin !== null && admin !== void 0 ? admin : publisher;
    const primaryError = adminPublisherError !== null && adminPublisherError !== void 0 ? adminPublisherError : publisherError;
    const [isExpanded, setIsExpanded] = (0, react_1.useState)(true);
    return (react_1.default.createElement("div", { className: (0, clsx_1.default)('publisher-component', isExpanded && 'expanded') },
        react_1.default.createElement(PublisherCard_1.default, { publisher: primary, isExpanded: isExpanded, toggleExpanded: () => setIsExpanded(!isExpanded), publicContact: publicContact, errors: primaryError, workType: workType }),
        admin && (react_1.default.createElement("div", { className: 'sub-publisher-component' },
            react_1.default.createElement("div", { className: 'svg-container' },
                react_1.default.createElement("svg", { "aria-hidden": 'true', role: 'img', focusable: 'false', "aria-labelledby": 'title', "data-testid": 'connector-svg', viewBox: '0, 0, 30, 71', preserveAspectRatio: 'none' },
                    react_1.default.createElement("title", null, "Admin Original Publisher Connecting Line"),
                    react_1.default.createElement("line", { vectorEffect: 'non-scaling-stroke', x1: 20, x2: 20, y1: 0, y2: 70, stroke: '#BDBDBD', strokeLinecap: 'square' }),
                    react_1.default.createElement("line", { vectorEffect: 'non-scaling-stroke', x1: 20, x2: 30, y1: 70, y2: 70, stroke: '#BDBDBD', strokeLinecap: 'square' }))),
            react_1.default.createElement(PublisherCard_1.default, { publisher: publisher, errors: publisherError, isSubPublisher: true })))));
};
exports.default = PublisherComponent;
